
// App
export const TOGGLE_DEVICE = 'TOGGLE_DEVICE';
export const SET_COUNTRY = 'SET_COUNTRY';

// Flow
export const SET_FLOW_TYPE = 'SET_FLOW_TYPE';

// Packages
export const LOADED_PACKAGES = 'LOADED_PACKAGES';
export const LOADED_LOAN_PACKAGES = 'LOADED_LOAN_PACKAGES';
export const SET_PACKAGES_TO_SHOW = 'SET_PACKAGES_TO_SHOW';
export const SET_PACKAGES_TYPE = 'SET_PACKAGES_TYPE';
export const SET_ROAMING_COVERAGE = 'SET_ROAMING_COVERAGE';
export const SET_ROAMING_TYPE = 'SET_ROAMING_TYPE';
export const SET_PACK = 'SET_PACK';
export const SET_LOAN = 'SET_LOAN';

// Purchases
export const SET_FRECUENCY = 'SET_FRECUENCY';
export const SET_USING_RENEW = 'SET_USING_RENEW';
export const SET_PRODUCT_TYPE = 'SET_PRODUCT_TYPE';
export const SET_ACEPTED_TERMS = 'SET_ACEPTED_TERMS';
export const SET_PURCHASE_RESULT = 'SET_PURCHASE_RESULT';
export const SET_RENEW_FRECUENCY = 'SET_RENEW_FRECUENCY';
export const SET_RECHARGE = 'SET_RECHARGE';

// Pin
export const SET_PIN_CONFIRMATION = 'SET_PIN_CONFIRMATION';

// Client
export const SET_GIFT = 'SET_GIFT';
export const SET_MSISDN = 'SET_MSISDN';
export const SET_BALANCE = 'SET_BALANCE';
export const SET_MOBILE_DATA = 'SET_MOBILE_DATA';
export const SET_CREDIT_LINE = 'SET_CREDIT_LINE';
export const SET_PROFILE_TYPE = 'SET_PROFILE_TYPE';
export const SET_APPLY_TO_LOAN = 'SET_APPLY_TO_LOAN';
export const SET_CLIENT_PROFILE = 'SET_CLIENT_PROFILE';
export const SET_USING_CREDIT_CARD = 'SET_USING_CREDIT_CARD';
export const SET_APPLY_TO_SPONSORSHIP = 'SET_APPLY_TO_SPONSORSHIP';

// Sidenav
export const TOGGLE_SIDENAV = 'TOGGLE_SIDENAV';

// Modals
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

// Navigation
export const SET_NAVIGATION = 'SET_NAVIGATION';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js